function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 399.46 54.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m113.81,49.38V14.17h-13.84v-6.56h35.44v6.56h-13.84v35.21h-7.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.77,49.38v-31.87h7.1v8.77l-.84-2.57c.95-2.15,2.46-3.78,4.51-4.89,2.05-1.11,4.6-1.67,7.67-1.67v7.1c-.32-.08-.62-.13-.9-.15-.28-.02-.56-.03-.84-.03-2.82,0-5.07.83-6.74,2.48-1.67,1.65-2.51,4.11-2.51,7.37v15.46h-7.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.32,49.8c-2.71,0-5.09-.51-7.16-1.52-2.07-1.01-3.68-2.57-4.83-4.65-1.15-2.09-1.73-4.72-1.73-7.91v-18.2h7.46v17.19c0,2.86.65,5,1.94,6.42,1.29,1.41,3.13,2.12,5.52,2.12,1.75,0,3.27-.36,4.56-1.07,1.29-.72,2.31-1.79,3.04-3.22.74-1.43,1.1-3.2,1.1-5.31v-16.11h7.46v31.87h-7.1v-8.59l1.25,2.62c-1.07,2.07-2.65,3.65-4.71,4.74-2.07,1.09-4.34,1.64-6.8,1.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.42,49.98c-3.26,0-6.38-.47-9.37-1.4s-5.35-2.14-7.1-3.61l2.69-6.03c1.67,1.31,3.74,2.41,6.21,3.28,2.47.88,4.99,1.31,7.58,1.31,2.19,0,3.96-.24,5.31-.72,1.35-.48,2.35-1.12,2.98-1.94.64-.81.96-1.74.96-2.77,0-1.27-.46-2.3-1.37-3.07-.92-.78-2.1-1.39-3.55-1.85-1.45-.46-3.06-.88-4.83-1.28-1.77-.4-3.54-.87-5.31-1.4-1.77-.54-3.38-1.23-4.83-2.09s-2.64-2-3.55-3.43c-.92-1.43-1.37-3.26-1.37-5.49s.61-4.35,1.82-6.24c1.21-1.89,3.06-3.4,5.55-4.54,2.49-1.13,5.64-1.7,9.46-1.7,2.51,0,4.99.32,7.46.96,2.47.64,4.61,1.55,6.44,2.74l-2.45,6.03c-1.87-1.11-3.8-1.94-5.79-2.48s-3.9-.81-5.73-.81c-2.15,0-3.89.26-5.22.78-1.33.52-2.31,1.19-2.92,2.03-.62.83-.92,1.79-.92,2.86,0,1.27.45,2.3,1.34,3.07.9.78,2.07,1.38,3.52,1.82,1.45.44,3.07.87,4.86,1.28,1.79.42,3.57.89,5.34,1.4,1.77.52,3.38,1.19,4.83,2.03,1.45.83,2.62,1.97,3.52,3.4.9,1.43,1.34,3.24,1.34,5.43s-.61,4.29-1.82,6.18c-1.21,1.89-3.07,3.4-5.58,4.54s-5.67,1.7-9.49,1.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.05,23.72v-5.97h21.24v5.97h-21.24Zm16.23,26.08c-3.5,0-6.21-.9-8.12-2.71-1.91-1.81-2.86-4.48-2.86-8.03V10.47h7.46v28.4c0,1.51.39,2.69,1.16,3.52.78.83,1.86,1.25,3.25,1.25,1.67,0,3.06-.44,4.18-1.31l2.09,5.31c-.88.72-1.95,1.25-3.22,1.61-1.27.36-2.59.54-3.94.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.19,49.8c-2.39,0-4.48-.41-6.27-1.22-1.79-.82-3.17-1.95-4.15-3.4-.98-1.45-1.46-3.09-1.46-4.92s.43-3.4,1.28-4.83c.86-1.43,2.26-2.57,4.21-3.4,1.95-.83,4.54-1.25,7.76-1.25h9.25v4.95h-8.71c-2.55,0-4.26.41-5.13,1.22-.88.82-1.31,1.82-1.31,3.01,0,1.35.54,2.43,1.61,3.22,1.07.8,2.57,1.19,4.48,1.19s3.47-.42,4.92-1.25c1.45-.84,2.5-2.07,3.13-3.7l1.25,4.48c-.72,1.87-2,3.32-3.85,4.36-1.85,1.04-4.19,1.55-7.01,1.55Zm10.03-.42v-6.44l-.42-1.37v-11.28c0-2.19-.66-3.89-1.97-5.1-1.31-1.21-3.3-1.82-5.97-1.82-1.79,0-3.55.28-5.28.84-1.73.56-3.19,1.33-4.39,2.33l-2.92-5.43c1.71-1.31,3.75-2.3,6.12-2.95s4.82-.98,7.37-.98c4.61,0,8.18,1.1,10.71,3.31,2.53,2.21,3.79,5.62,3.79,10.23v18.68h-7.04Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.49,49.8c-3.34,0-6.32-.71-8.92-2.12-2.61-1.41-4.65-3.35-6.12-5.82-1.47-2.47-2.21-5.27-2.21-8.41s.74-6,2.21-8.44c1.47-2.45,3.51-4.37,6.12-5.76,2.61-1.39,5.58-2.09,8.92-2.09,3.1,0,5.84.63,8.21,1.88,2.37,1.25,4.17,3.09,5.4,5.52l-5.73,3.34c-.96-1.51-2.12-2.62-3.49-3.34-1.37-.72-2.85-1.07-4.45-1.07-1.83,0-3.48.4-4.95,1.19s-2.62,1.94-3.46,3.43c-.83,1.49-1.25,3.27-1.25,5.34s.42,3.85,1.25,5.34c.84,1.49,1.99,2.64,3.46,3.43,1.47.8,3.12,1.19,4.95,1.19,1.59,0,3.07-.36,4.45-1.07,1.37-.72,2.54-1.83,3.49-3.34l5.73,3.34c-1.23,2.39-3.03,4.23-5.4,5.52-2.37,1.29-5.1,1.94-8.21,1.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.24,49.38V5.1h7.46v44.28h-7.46Zm6.09-7.1l.18-9.37,16.65-15.4h8.95l-14.14,14.2-3.94,3.28-7.7,7.28Zm17.96,7.1l-11.64-14.38,4.71-5.97,15.99,20.35h-9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.02,49.8c-2.67,0-5.22-.35-7.67-1.04s-4.39-1.54-5.82-2.54l2.86-5.67c1.43.92,3.14,1.67,5.13,2.27s3.98.9,5.97.9c2.35,0,4.05-.32,5.1-.96,1.05-.64,1.58-1.49,1.58-2.57,0-.88-.36-1.54-1.07-2-.72-.46-1.65-.81-2.8-1.04-1.15-.24-2.44-.46-3.85-.66-1.41-.2-2.83-.47-4.24-.81-1.41-.34-2.7-.83-3.85-1.49-1.15-.66-2.09-1.54-2.8-2.66-.72-1.11-1.07-2.59-1.07-4.42,0-2.03.58-3.79,1.73-5.28,1.15-1.49,2.77-2.64,4.86-3.46,2.09-.81,4.56-1.22,7.43-1.22,2.15,0,4.32.24,6.5.72,2.19.48,4,1.15,5.43,2.03l-2.86,5.67c-1.51-.91-3.03-1.54-4.56-1.88-1.53-.34-3.05-.51-4.57-.51-2.27,0-3.95.34-5.04,1.01-1.09.68-1.64,1.53-1.64,2.57,0,.96.36,1.67,1.07,2.15.72.48,1.65.86,2.8,1.13,1.15.28,2.44.51,3.85.69,1.41.18,2.81.45,4.21.81,1.39.36,2.68.85,3.85,1.46,1.17.62,2.12,1.48,2.83,2.6.72,1.11,1.07,2.57,1.07,4.36,0,1.99-.59,3.72-1.76,5.19-1.17,1.47-2.83,2.62-4.98,3.43-2.15.81-4.71,1.22-7.7,1.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.23,
    y: 0.75,
    width: 54,
    height: 13.5,
    style: {
      fill: "#897dbb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.73,
    y: 21,
    width: 40.5,
    height: 13.5,
    style: {
      fill: "#897dbb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.23,
    y: 41.25,
    width: 54,
    height: 13.5,
    style: {
      fill: "#76cabc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.23,
    y: 21,
    width: 40.5,
    height: 13.5,
    style: {
      fill: "#76cabc"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1bec97fbda06e9fa962d8c3af82c889e.svg";
export { ForwardRef as ReactComponent };